(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ultreia-about-journey"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-abjrny]').forEach(function (root) {
      var track = root.querySelector('[data-abjrny-track]');
      var prev = root.querySelector('[data-abjrny-prev]');
      var next = root.querySelector('[data-abjrny-next]');
      if (!track || !prev || !next) return;

      var originals = Array.prototype.slice.call(track.querySelectorAll('.u-abjrny__card'));
      if (originals.length < 2) return;

      // Clone the full set on both sides so the row has runway to wrap in either
      // direction. Layout: [clones] [originals] [clones]; we keep scrollLeft parked
      // inside the middle (originals) band, jumping by one set-width at the seams.
      function makeClones() {
        return originals.map(function (card) {
          var clone = card.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          clone.classList.add('u-abjrny__card--clone');
          return clone;
        });
      }
      var leading = makeClones();
      var trailing = makeClones();
      leading.forEach(function (c) { track.insertBefore(c, originals[0]); });
      trailing.forEach(function (c) { track.appendChild(c); });

      function gap() { return parseFloat(getComputedStyle(track).columnGap || '20') || 20; }
      function setWidth() {
        var g = gap(), w = 0;
        originals.forEach(function (card) { w += card.getBoundingClientRect().width + g; });
        return w;
      }
      function step() {
        var card = originals[0];
        return card ? card.getBoundingClientRect().width + gap() : 320;
      }

      var setW = 0;
      function park() { setW = setWidth(); track.scrollLeft = setW; }

      var wrapping = false;
      function wrap() {
        if (wrapping || setW <= 0) return;
        // Once we drift a full set past the middle band, snap back by one set-width.
        if (track.scrollLeft >= setW * 2) { wrapping = true; track.scrollLeft -= setW; wrapping = false; }
        else if (track.scrollLeft < setW) { wrapping = true; track.scrollLeft += setW; wrapping = false; }
      }
      track.addEventListener('scroll', wrap, { passive: true });
      window.addEventListener('resize', park);

      prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

      // Click-and-drag to scroll (desktop). Pointer events cover mouse + pen; touch
      // keeps its native scrolling. A small threshold prevents drags from eating clicks.
      var down = false, startX = 0, startScroll = 0, moved = false;
      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;
        down = true; moved = false;
        startX = e.clientX; startScroll = track.scrollLeft;
        track.classList.add('is-dragging');
      });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        track.scrollLeft = startScroll - dx;
      });
      function endDrag() {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
      }
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);
      track.addEventListener('pointerleave', endDrag);
      // Swallow the click that follows a real drag so card links don't fire.
      track.addEventListener('click', function (e) {
        if (moved) { e.preventDefault(); e.stopPropagation(); moved = false; }
      }, true);
      track.addEventListener('dragstart', function (e) { e.preventDefault(); });

      // Park after layout/images settle so setWidth is accurate.
      park();
      requestAnimationFrame(park);
      window.addEventListener('load', park);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-all-brands"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-abrands]').forEach(function (section) {
      if (section.dataset.abrandsInit) return;
      section.dataset.abrandsInit = '1';

      var viewport = section.querySelector('.u-abrands__viewport');
      var track = section.querySelector('[data-abrands-track]');
      var prev = section.querySelector('[data-abrands-prev]');
      var next = section.querySelector('[data-abrands-next]');
      if (!viewport || !track) return;

      function updateArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.toggleAttribute('data-hidden', atStart);
        if (next) next.toggleAttribute('data-hidden', atEnd);
      }

      function markOverflow() {
        if (track.scrollWidth > track.clientWidth + 4) {
          viewport.setAttribute('data-overflow', '');
        } else {
          viewport.removeAttribute('data-overflow');
        }
        updateArrows();
      }
      markOverflow();
      window.addEventListener('resize', markOverflow);
      track.addEventListener('scroll', updateArrows, { passive: true });

      function scrollByStep(dir) {
        var item = track.querySelector('.u-abrands__item');
        var step = item ? item.getBoundingClientRect().width + 16 : 220;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
      if (next) next.addEventListener('click', function () { scrollByStep(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-bundle-showcase"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function money(cents) {
      var n = cents / 100;
      return '$ ' + n.toLocaleString('en-US', { minimumFractionDigits: n % 1 ? 2 : 0, maximumFractionDigits: 2 });
    }

    function init(root) {
      if (root.dataset.bshowInit) return;
      root.dataset.bshowInit = '1';

      var items = Array.prototype.slice.call(root.querySelectorAll('[data-bshow-item]'));
      var percent = parseFloat(root.dataset.percent) || 0;
      var fixed = parseInt(root.dataset.fixed, 10) || 0;
      var totalEl = root.querySelector('[data-bshow-total]');
      var wasEl = root.querySelector('[data-bshow-was]');
      var saveEl = root.querySelector('[data-bshow-save]');
      var addBtn = root.querySelector('[data-bshow-add]');
      var addLabel = addBtn && addBtn.querySelector('[data-bshow-add-label]');

      // Re-total from the currently selected variant of each card (sizes can
      // differ in price), mirroring the Liquid arithmetic.
      function recalc() {
        var subtotal = 0;
        items.forEach(function (it) {
          var sel = it.querySelector('select[data-bshow-variant]');
          var price = parseInt(it.dataset.price, 10) || 0;
          if (sel && sel.selectedOptions[0]) {
            price = parseInt(sel.selectedOptions[0].dataset.price, 10) || price;
            var pe = it.querySelector('[data-bshow-price]');
            if (pe) pe.textContent = money(price);
          }
          subtotal += price;
        });
        var total = subtotal;
        if (fixed > 0) total = fixed;
        else if (percent > 0) total = Math.round(subtotal * (100 - percent) / 10000) * 100;
        if (totalEl) totalEl.textContent = money(total);
        if (wasEl) wasEl.textContent = money(subtotal);
        if (saveEl && subtotal > 0 && total < subtotal) {
          var amount = money(subtotal - total);
          var pct = Math.round((subtotal - total) * 100 / subtotal);
          saveEl.innerHTML = saveEl.innerHTML.replace(/\$\s?[\d,.]+/, amount).replace(/\d+\s*%/, pct + '%');
        }
      }
      root.addEventListener('change', function (e) {
        if (e.target.matches('select[data-bshow-variant]')) recalc();
      });

      // "Choose one" card: switching option swaps the card's image, name, link
      // and size list, then re-totals the kit.
      root.querySelectorAll('.u-bshow__opt[aria-checked="true"]').forEach(function (b) {
        b.parentNode.scrollLeft = b.offsetLeft - b.parentNode.offsetLeft - 16;
      });
      function esc(s) { var d = document.createElement('div'); d.textContent = s; return d.innerHTML; }
      root.addEventListener('click', function (e) {
        var opt = e.target.closest('.u-bshow__opt');
        if (!opt || opt.disabled || !root.contains(opt)) return;
        var it = opt.closest('[data-bshow-item]');
        var variants = [];
        try { variants = JSON.parse(opt.dataset.variants); } catch (err) {}
        if (!variants.length) return;

        it.querySelectorAll('.u-bshow__opt').forEach(function (b) { b.setAttribute('aria-checked', b === opt ? 'true' : 'false'); });
        var img = it.querySelector('[data-bshow-link] .u-bshow__img');
        if (img && opt.dataset.img) { img.removeAttribute('srcset'); img.removeAttribute('sizes'); img.src = opt.dataset.img; }
        it.querySelectorAll('[data-bshow-link], [data-bshow-name]').forEach(function (a) { a.href = opt.dataset.url; });
        var name = it.querySelector('[data-bshow-name]');
        if (name) name.textContent = opt.dataset.title;

        var sel = it.querySelector('select[data-bshow-variant]');
        if (sel) {
          var first = variants.filter(function (v) { return v.a; })[0] || variants[0];
          sel.innerHTML = variants.map(function (v) {
            return '<option value="' + v.id + '" data-price="' + v.p + '"' + (v.a ? '' : ' disabled') + (v === first ? ' selected' : '') + '>' +
              esc(v.t) + (v.a ? '' : ' — Agotado') + '</option>';
          }).join('');
          sel.closest('.u-bshow__variant').hidden = variants.length < 2;
          it.dataset.price = first.p;
        }
        recalc();
      });

      if (!addBtn) return;
      var defaultLabel = addBtn.dataset.label;
      addBtn.addEventListener('click', function () {
        if (addBtn.disabled || addBtn.getAttribute('aria-busy') === 'true') return;
        var lines = items.map(function (it) {
          var input = it.querySelector('[data-bshow-variant]');
          return { id: parseInt(input && input.value, 10), quantity: 1, properties: { _kit: root.dataset.kit } };
        }).filter(function (l) { return l.id; });
        if (!lines.length) return;

        addBtn.setAttribute('aria-busy', 'true');
        addLabel.textContent = 'Agregando…';
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: lines })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            var countEl = document.querySelector('.u-bag__count');
            if (countEl) { countEl.textContent = cart.item_count; countEl.setAttribute('data-count', cart.item_count); }
            document.dispatchEvent(new CustomEvent('ultreia:cart:add', { detail: { cart: cart, kit: root.dataset.kit } }));
            addLabel.textContent = 'Agregado a la mochila ✓';
            setTimeout(function () { addBtn.removeAttribute('aria-busy'); addLabel.textContent = defaultLabel; }, 1800);
          })
          .catch(function (err) {
            addBtn.removeAttribute('aria-busy');
            addLabel.textContent = (err && err.description) ? err.description : 'Error, intenta de nuevo';
            setTimeout(function () { addLabel.textContent = defaultLabel; }, 2600);
          });
      });
    }

    function initAll() { document.querySelectorAll('[data-bshow]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-bundle"] && !Shopify.designMode) return;
  try {
    
  /* ULTREIA bundle runtime. Reads the bundle from window.bndlr, hydrates product
     data from /products/{handle}.js, renders on-brand cards with variant pickers,
     and adds the whole set to the cart via /cart/add.js. Bundler's automatic
     discount applies at checkout on its own. */
  (function () {
    var root = document.querySelector('[data-ultreia-bundle]');
    if (!root || root.dataset.bundleInit) return;
    root.dataset.bundleInit = '1';

    var I18N = {}; try { I18N = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}

    var listEl = root.querySelector('[data-bundle-list]');
    var tabsEl = root.querySelector('[data-bundle-tabs]');
    var currentHandle = root.dataset.currentHandle || '';
    var rendered = false;            // becomes true once we've drawn the bundles
    var renderedIds = {};            // bundle id -> true, so we never double-render
    var tabSeq = 0;                  // running 01, 02, … for the tab numbers

    // Reveal coordination: we hold the band hidden until EVERY applicable bundle
    // has finished hydrating, then reveal once — so the tab strip and all panels
    // appear together. Revealing per-bundle (as fetches resolved) made the tabs
    // pop in after the first panel was already visible (a double visual change).
    var expectedBundles = 0;         // how many applicable bundles we're waiting on
    var settledBundles = 0;          // how many have hydrated (ok or failed)
    var revealed = false;
    function revealWhenReady() {
      if (revealed || !rendered) return;
      // Reveal once all expected bundles have settled and at least one drew cards.
      if (settledBundles < expectedBundles) return;
      if (!listEl.querySelector('.u-bundle__group')) return; // nothing rendered
      revealed = true;
      if (root.hidden) { root.hidden = false; root.classList.add('is-ready'); }
    }

    // Show one panel (and mark its tab active); hide the others.
    function activateBundle(id) {
      var tabs = tabsEl.querySelectorAll('.u-bundle__tab');
      for (var i = 0; i < tabs.length; i++) {
        var on = tabs[i].getAttribute('data-tab-id') === String(id);
        tabs[i].classList.toggle('is-active', on);
        tabs[i].setAttribute('aria-selected', on ? 'true' : 'false');
      }
      var panels = listEl.querySelectorAll('.u-bundle__group');
      for (var j = 0; j < panels.length; j++) {
        panels[j].hidden = panels[j].getAttribute('data-bundle-id') !== String(id);
      }
    }

    function esc(s) {
      return String(s == null ? '' : s)
        .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    function money(cents) {
      // Lightweight MXN-style formatter matching the storefront's $1,234 look.
      var n = (cents / 100);
      return '$' + n.toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 });
    }

    function discountedTotal(bundle, subtotal) {
      if (bundle.discount_type === 'percentage') {
        var pct = parseFloat(bundle.percentage_value || '0');
        return Math.round(subtotal * (1 - pct / 100));
      }
      if (bundle.discount_type === 'fixed_amount') {
        var amt = Math.round(parseFloat(bundle.fixed_amount_value || '0') * 100);
        return Math.max(0, subtotal - amt);
      }
      if (bundle.discount_type === 'fixed_price') {
        return Math.round(parseFloat(bundle.fixed_price_value || '0') * 100);
      }
      return subtotal;
    }

    /* Build one self-contained bundle block. All per-bundle state (products,
       selected variants, DOM refs) lives in this closure so multiple bundles on
       the same product never share or clobber each other's state. */
    function renderBundle(bundle, products) {
      var selected = {};   // handle -> chosen variant object, scoped to THIS bundle

      // Tab number (01, 02, …) and label for this bundle's tab.
      tabSeq++;
      var tabNum = (tabSeq < 10 ? '0' : '') + tabSeq;
      var tabLabel = bundle.name || bundle.title ||
        ((I18N.tabLabelFallbackHtml || 'Paquete %{number}').replace('%{number}', tabSeq));

      var tab = document.createElement('button');
      tab.type = 'button';
      tab.className = 'u-bundle__tab';
      tab.setAttribute('role', 'tab');
      tab.setAttribute('data-tab-id', bundle.id);
      tab.innerHTML =
        '<span class="u-bundle__tab-num">' + esc(tabNum) + '</span>' +
        '<span class="u-bundle__tab-label">' + esc(tabLabel) + '</span>';
      tab.addEventListener('click', function () { activateBundle(bundle.id); });
      tabsEl.appendChild(tab);

      var group = document.createElement('div');
      group.className = 'u-bundle__group';
      group.setAttribute('data-bundle-id', bundle.id);
      // Start hidden; activateBundle() reveals exactly one. Without this, a panel
      // that renders AFTER the first one was activated would show alongside it
      // (activateBundle only hides panels that exist when it runs).
      group.hidden = true;
      group.innerHTML =
        // Left rail: title, description, price box, add button.
        '<div class="u-bundle__rail">' +
          '<h3 class="u-bundle__panel-title">' + esc(tabLabel) + '</h3>' +
          (bundle.description ? '<p class="u-bundle__lead">' + esc(bundle.description) + '</p>' : '') +
          '<div class="u-bundle__price-box">' +
            '<span class="u-bundle__price-label">' + esc(I18N.priceLabel || 'Precio del paquete completo') + '</span>' +
            '<div class="u-bundle__totals">' +
              '<span class="u-bundle__total-now"></span>' +
              '<span class="u-bundle__total-was" hidden></span>' +
            '</div>' +
            '<span class="u-bundle__save" hidden></span>' +
          '</div>' +
          '<button type="button" class="u-bundle__add">' +
            '<span class="u-bundle__add-label">' + esc(bundle.button_text || I18N.addToCart || 'Agregar el paquete') + '</span>' +
            '<span class="u-bundle__add-arrow" aria-hidden="true">→</span>' +
          '</button>' +
          (bundle.discount_warning ? '<p class="u-bundle__fineprint">' + esc(bundle.discount_warning) + '</p>' : '') +
        '</div>' +
        // Right: grid of product cards.
        '<div class="u-bundle__items"></div>';

      var itemsEl = group.querySelector('.u-bundle__items');
      var nowEl = group.querySelector('.u-bundle__total-now');
      var wasEl = group.querySelector('.u-bundle__total-was');
      var saveEl = group.querySelector('.u-bundle__save');
      var addBtn = group.querySelector('.u-bundle__add');
      var addLabel = group.querySelector('.u-bundle__add-label');
      var defaultAddLabel = addLabel.textContent;

      function paintItemPrice(card, v) {
        var el = card.querySelector('.u-bundle__price');
        if (el && v) el.textContent = money(v.price);
      }

      function recalcTotals() {
        var subtotal = 0, allChosen = true;
        products.forEach(function (p) {
          var v = selected[p.handle];
          if (v) { subtotal += v.price; } else { allChosen = false; }
        });
        var final = discountedTotal(bundle, subtotal);
        nowEl.textContent = money(final);
        if (subtotal > final && subtotal > 0) {
          wasEl.textContent = money(subtotal); wasEl.hidden = false;
          var pct = Math.round((subtotal - final) / subtotal * 100);
          saveEl.textContent = (I18N.saveHtml || 'Ahorras %{amount} · %{percent}%')
            .replace('%{amount}', money(subtotal - final)).replace('%{percent}', pct);
          saveEl.hidden = false;
        } else {
          wasEl.hidden = true; saveEl.hidden = true;
        }
        var anyUnavailable = products.some(function (p) {
          var v = selected[p.handle];
          return !v || !v.available;
        });
        addBtn.disabled = !allChosen || anyUnavailable || products.length === 0;
      }

      function buildCard(p, i) {
        var card = document.createElement('div');
        // NOTE: we deliberately do NOT add Bundler's `.bndlr-product` class here.
        // The discount is automatic and does not depend on our markup, and that
        // class makes Bundler's global CSS style our cards (it injects blue "+"
        // connectors via ::before/::after). Our own data-bundle-handle is enough.
        card.className = 'u-bundle__item';
        card.setAttribute('data-bundle-handle', p.handle);

        var img = (p.featured_image || (p.images && p.images[0]) || '');
        var imgSrc = img ? esc(img + (img.indexOf('?') === -1 ? '?' : '&') + 'width=600') : '';
        var imgHtml = img
          ? '<img class="u-bundle__img" src="' + imgSrc + '" alt="" loading="lazy" decoding="async">'
          : '<div class="u-bundle__img u-bundle__img--empty" aria-hidden="true"></div>';

        // Numbered gold badge (1-based) over the image, like the mockup.
        var badge = '<span class="u-bundle__badge" aria-hidden="true">' + (i + 1) + '</span>';
        // The current product gets an "ESTE PRODUCTO" tag.
        var isCurrent = currentHandle && p.handle === currentHandle;
        var thisTag = isCurrent ? '<span class="u-bundle__thistag">' + esc(I18N.thisProduct || 'Este producto') + '</span>' : '';

        var vendor = p.vendor ? '<span class="u-bundle__vendor">' + esc(p.vendor) + '</span>' : '';
        // A product has REAL variants only if it has more than one, or its single
        // variant isn't Shopify's placeholder "Default Title". (The /products/x.js
        // `options` field is unreliable for this — it can be strings or objects —
        // so we key off the variant title instead, which is always "Default Title"
        // for a no-option product.)
        var hasRealVariants = p.variants.length > 1 ||
          (p.variants.length === 1 && p.variants[0].title !== 'Default Title');
        var optionsHtml = hasRealVariants ? '<div class="u-bundle__variants"></div>' : '';

        if (isCurrent) card.classList.add('is-current');

        card.innerHTML =
          '<a class="u-bundle__media" href="/products/' + esc(p.handle) + '" tabindex="-1">' +
            thisTag + badge + imgHtml +
          '</a>' +
          '<div class="u-bundle__body">' +
            vendor +
            '<a class="u-bundle__name" href="/products/' + esc(p.handle) + '">' + esc(p.title) + '</a>' +
            '<span class="u-bundle__price"></span>' +
            optionsHtml +
          '</div>';

        itemsEl.appendChild(card);
        // Swap in the real brand + make it link to the tienda filtered by it.
        if (window.UltreiaBrand) window.UltreiaBrand.apply(card.querySelector('.u-bundle__vendor'), p.handle);

        if (hasRealVariants) {
          var vWrap = card.querySelector('.u-bundle__variants');
          p.variants.forEach(function (v) {
            var chip = document.createElement('button');
            chip.type = 'button';
            chip.className = 'u-bundle__chip';
            chip.textContent = v.public_title || v.title;
            chip.disabled = !v.available;
            chip.setAttribute('data-variant-id', v.id);
            chip.addEventListener('click', function () {
              selected[p.handle] = v;
              vWrap.querySelectorAll('.u-bundle__chip').forEach(function (c) {
                c.classList.toggle('is-selected', c === chip);
              });
              paintItemPrice(card, v);
              recalcTotals();
            });
            vWrap.appendChild(chip);
          });
        }

        // Default selection: first available variant (or first if none available).
        var firstAvail = p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
        selected[p.handle] = firstAvail;
        if (hasRealVariants && firstAvail) {
          var btn = card.querySelector('[data-variant-id="' + firstAvail.id + '"]');
          if (btn) btn.classList.add('is-selected');
        }
        paintItemPrice(card, firstAvail);
      }

      function addToCart() {
        if (!window.fetch || addBtn.disabled) return;
        var items = products.map(function (p) {
          return { id: selected[p.handle].id, quantity: 1, properties: { _bundle: String(bundle.id) } };
        });
        addBtn.setAttribute('aria-busy', 'true');
        addLabel.textContent = 'Agregando…';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: items })
        })
          .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
          .then(function () {
            return fetch('/cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
          })
          .then(function (cart) {
            var countEl = document.querySelector('.u-bag__count');
            if (countEl) { countEl.textContent = cart.item_count; countEl.setAttribute('data-count', cart.item_count); }
            document.dispatchEvent(new CustomEvent('ultreia:cart:add', { detail: { cart: cart, bundle: bundle.id } }));
            addLabel.textContent = I18N.added || 'Agregado ✓';
            setTimeout(function () { addBtn.removeAttribute('aria-busy'); addLabel.textContent = defaultAddLabel; }, 1600);
          })
          .catch(function () {
            addBtn.removeAttribute('aria-busy');
            addLabel.textContent = I18N.errorRetry || 'Error, reintentar';
            setTimeout(function () { addLabel.textContent = defaultAddLabel; }, 1800);
          });
      }
      addBtn.addEventListener('click', addToCart);

      products.forEach(buildCard);
      recalcTotals();
      listEl.appendChild(group);

      // Activate the first bundle that lands (fetches can resolve out of order).
      if (!tabsEl.querySelector('.u-bundle__tab.is-active')) activateBundle(bundle.id);
    }

    function hydrate(bundle) {
      if (renderedIds[bundle.id]) return;
      renderedIds[bundle.id] = true;

      // Bundle products are a keyed object; order by `sequence`, but pull the
      // current product to the front so it reads as "Este producto" / card #1.
      var list = Object.keys(bundle.products || {}).map(function (k) { return bundle.products[k]; });
      list.sort(function (a, c) {
        if (currentHandle) {
          if (a.handle === currentHandle) return -1;
          if (c.handle === currentHandle) return 1;
        }
        return (a.sequence || 0) - (c.sequence || 0);
      });

      // Fetch full product data (variants/price/image) per handle.
      Promise.all(list.map(function (bp) {
        return fetch('/products/' + bp.handle + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .catch(function () { return null; });
      })).then(function (fetched) {
        var products = fetched.filter(Boolean);
        if (!products.length) {
          renderedIds[bundle.id] = false; // allow a retry
        } else {
          renderBundle(bundle, products);
        }
      }).then(function () {
        // Count this bundle as settled whether it drew cards or not, so one bad
        // fetch can't keep the whole band hidden forever.
        settledBundles++;
        revealWhenReady();
      });
    }

    // Does this bundle actually contain the product we're viewing? getBundles()
    // returns EVERY bundle in the store, not just ones for this product, so we
    // must match the current handle against the bundle's product set ourselves.
    function bundleHasCurrentProduct(b) {
      if (!currentHandle || !b.products) return false;
      var keys = Object.keys(b.products);
      for (var i = 0; i < keys.length; i++) {
        if (b.products[keys[i]].handle === currentHandle) return true;
      }
      return false;
    }

    function pickBundles() {
      if (!window.bndlr || typeof window.bndlr.getBundles !== 'function') return false;
      var all = window.bndlr.getBundles();
      if (!all || !all.length) return false;
      // Render every enabled specific-products bundle that CONTAINS this product
      // (a product can be in several), ordered by priority, deduped via renderedIds.
      var applicable = all.filter(function (b) {
        return b.status === 'enabled' &&
          b.product_target_type === 'specific_products' &&
          b.products &&
          bundleHasCurrentProduct(b);
      }).sort(function (a, c) { return (c.priority || 0) - (a.priority || 0); });
      if (!applicable.length) return false;
      rendered = true;
      // Only count bundles we haven't already started hydrating; pickBundles can
      // fire more than once (events + poll) and hydrate() dedupes via renderedIds.
      var fresh = applicable.filter(function (b) { return !renderedIds[b.id]; });
      expectedBundles += fresh.length;
      fresh.forEach(hydrate);
      return true;
    }

    // bndlr may load before or after us — try on its events and poll as backup.
    document.addEventListener('bundler:loaded', pickBundles);
    document.addEventListener('bundler:bundle_widget_created', pickBundles);
    var tries = 0;
    var poll = setInterval(function () {
      tries++;
      if (rendered || pickBundles() || tries > 20) clearInterval(poll);
    }, 500);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-cart"] && !Shopify.designMode) return;
  try {
    
  /* Progressive enhancement over the native cart <form>. With JS off the form
     still works: the stepper writes its quantity into the name="updates[]" input
     and "Actualizar" / "Finalizar compra" submit the form. With JS on we hit the
     AJAX Cart API and re-render the section in place. */
  (function () {
    const root = document.querySelector('[data-cart-root]');
    if (!root) return;

    const sectionId = root.getAttribute('data-section-id');
    const changeUrl = root.getAttribute('data-change-url');
    const cartUrl = root.getAttribute('data-cart-url');
    let busy = false;

    // Pull the freshly-rendered <form> out of a Section Rendering API response and
    // swap it into the live DOM, so prices, line totals and the summary refresh.
    function applySection(html) {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const fresh = doc.querySelector('[data-cart-root]');
      const current = document.querySelector('[data-cart-root]');
      if (fresh && current) {
        const prev = snapshot(current);
        current.replaceWith(fresh);
        const next = document.querySelector('[data-cart-root]');
        animateFrom(next, prev);
        bind(next);
        if (window.ultreiaFoodStrip) window.ultreiaFoodStrip(next);
      }
    }

    // What a re-render would otherwise snap: the stamp ring, the phone progress
    // card and the carousel's sideways scroll.
    function snapshot(scope) {
      const ring = scope.querySelector('[data-stamp-ring]');
      const card = scope.querySelector('[data-cart-progress]');
      const track = scope.querySelector('[data-food-track]');
      const stamp = scope.querySelector('.u-cart__bag .u-backpack__stamp');
      const icons = {};
      scope.querySelectorAll('.u-cart__bag [data-icon]').forEach(el => { icons[el.getAttribute('data-icon')] = parseInt(el.getAttribute('data-qty'), 10) || 0; });
      const bar = scope.querySelector('[data-stamp-bar]');
      return {
        bar: bar ? bar.style.width : null,
        icons: icons,
        reached: !!(stamp && stamp.classList.contains('is-reached')),
        ring: ring ? ring.getAttribute('stroke-dasharray') : null,
        pct: card ? card.getAttribute('data-pct') : null,
        scroll: track ? track.scrollLeft : 0
      };
    }

    // Start the fresh ring / bar / level at their old values, then let the CSS
    // transitions carry them to the new ones.
    function animateFrom(scope, prev) {
      const track = scope.querySelector('[data-food-track]');
      if (track && prev.scroll) track.scrollLeft = prev.scroll;
      const stamp = scope.querySelector('.u-cart__bag .u-backpack__stamp');
      if (stamp && !prev.reached && stamp.classList.contains('is-reached')) stamp.classList.add('is-stamping');
      const bar = scope.querySelector('[data-stamp-bar]');
      if (bar && prev.bar && prev.bar !== bar.style.width) {
        const nextBar = bar.style.width;
        bar.style.width = prev.bar;
        void bar.offsetWidth;
        requestAnimationFrame(() => { bar.style.width = nextBar; });
      }
      // Drop in the icon of whatever was just added (new kind or higher count),
      // and squash the backpack on any change to what's inside.
      let bagChanged = false;
      const seen = {};
      scope.querySelectorAll('.u-cart__bag [data-icon]').forEach(el => {
        const code = el.getAttribute('data-icon');
        const qty = parseInt(el.getAttribute('data-qty'), 10) || 0;
        seen[code] = true;
        const before = prev.icons[code] || 0;
        if (qty !== before) bagChanged = true;
        if (qty > before) el.classList.add('is-dropping');
      });
      Object.keys(prev.icons).forEach(code => { if (!seen[code]) bagChanged = true; });
      const art = scope.querySelector('.u-cart__bag .u-backpack__art');
      if (art && bagChanged) art.classList.add('is-bump');
      const ring = scope.querySelector('[data-stamp-ring]');
      const card = scope.querySelector('[data-cart-progress]');
      const fill = card && card.querySelector('[data-progress-fill]');
      const level = card && card.querySelector('[data-backpack-level]');
      const nextRing = ring && ring.getAttribute('stroke-dasharray');
      const nextPct = card && card.getAttribute('data-pct');
      if (ring && prev.ring && prev.ring !== nextRing) ring.setAttribute('stroke-dasharray', prev.ring);
      if (card && prev.pct != null && prev.pct !== nextPct) {
        if (fill) fill.style.width = prev.pct + '%';
        if (level) level.style.bottom = prev.pct + '%';
      } else if (!(ring && prev.ring && prev.ring !== nextRing)) {
        return;
      }
      void scope.offsetWidth;
      requestAnimationFrame(() => {
        if (ring && nextRing) ring.setAttribute('stroke-dasharray', nextRing);
        if (card && nextPct != null) {
          if (fill) fill.style.width = nextPct + '%';
          if (level) level.style.bottom = nextPct + '%';
          card.classList.add('is-bump');
        }
      });
    }

    // Re-render without a change of our own (adds from the carousel, quick-shop
    // or anywhere else on the page).
    function refresh() {
      fetch(cartUrl + '?section_id=' + encodeURIComponent(sectionId), { headers: { Accept: 'text/html' } })
        .then(r => (r.ok ? r.text() : null))
        .then(html => { if (html) applySection(html); })
        .catch(() => {});
    }

    function syncBadge(count) {
      // Keep the navbar bag badge in step with the cart.
      document.querySelectorAll('[data-bag-count], .u-bag__count').forEach(b => {
        b.textContent = count;
        b.setAttribute('data-count', count);
      });
    }

    // The live cart root. applySection() replaces the root element on every change,
    // so the closure-captured `root` goes stale (detached) after the first swap —
    // always re-query for state that must land on the element currently in the DOM
    // (e.g. aria-busy, which drives the veil), or the veil only ever shows once.
    function liveRoot() { return document.querySelector('[data-cart-root]') || root; }

    // Flip the cart into its busy state: blocks re-entry (callers check `busy`
    // first) and shows the table veil via aria-busy. The remove flow calls this at
    // click — before the collapse — so the veil + lockout cover the whole operation;
    // change() calls it too, which is then a harmless no-op.
    function beginBusy() {
      busy = true;
      liveRoot().setAttribute('aria-busy', 'true');
    }

    function change(line, quantity, row) {
      beginBusy();
      // Mark the row whose total is being recalculated so its line total (and the
      // summary) can dim + pulse while the server round-trips — otherwise the
      // ~1s wait looks like nothing happened.
      if (row) row.setAttribute('data-busy', '');
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: quantity, sections: sectionId })
      })
        .then(r => r.json())
        .then(state => {
          syncBadge(state.item_count);
          if (state.sections && state.sections[sectionId]) {
            applySection(state.sections[sectionId]);
          } else {
            window.location.reload();
          }
          // Let any product-card buy buttons elsewhere on the page re-evaluate
          // their stock cap against the changed cart.
          document.dispatchEvent(new CustomEvent('ultreia:cart:change', { detail: { cart: state, source: 'cart-page' } }));
        })
        .catch(() => { window.location.href = cartUrl; })
        .finally(() => { busy = false; });
    }

    function bind(scope) {
      const cartRoot = scope || root;
      if (!cartRoot) return;

      cartRoot.querySelectorAll('[data-cart-item]').forEach(row => {
        const line = parseInt(row.getAttribute('data-line'), 10);
        const input = row.querySelector('[data-qty-input]');
        const dec = row.querySelector('[data-dec]');
        const inc = row.querySelector('[data-inc]');
        // Stock ceiling for inventory-tracked variants (data-max on the row); the
        // server already disables "+" at the cap, this is the client-side guard so
        // a typed value or rapid clicks can't exceed it either. Absent → uncapped.
        const rawMax = row.getAttribute('data-max');
        const max = rawMax === null ? Infinity : parseInt(rawMax, 10);

        // Removal (trash, "−" at 1, or a typed 0): collapse the row to zero height
        // (rows below glide up to fill the gap), THEN fire the change so the fresh
        // section swaps in under an already-collapsed row — no hard snap. The veil
        // goes up at the same instant, blocking re-entry. The height is pinned
        // first so max-height has a concrete value to transition from.
        function removeRow() {
          beginBusy();
          const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          const collapseMs = reduceMotion ? 150 : 280;
          row.style.maxHeight = row.offsetHeight + 'px';
          void row.offsetHeight;
          requestAnimationFrame(() => {
            row.setAttribute('data-removing', '');
            row.style.maxHeight = '0px';
          });
          setTimeout(() => change(line, 0, row), collapseMs);
        }

        if (dec) dec.addEventListener('click', () => {
          if (busy) return;
          const next = Math.max(0, parseInt(input.value, 10) - 1);
          if (next === 0) { removeRow(); return; }
          input.value = next;
          change(line, next, row);
        });
        if (inc) inc.addEventListener('click', () => {
          if (busy || inc.hasAttribute('disabled')) return;
          const next = Math.min(max, parseInt(input.value, 10) + 1);
          // Already at the cap → nothing to do (avoids a no-op round-trip).
          if (next === parseInt(input.value, 10)) return;
          input.value = next;
          change(line, next, row);
        });
        if (input) input.addEventListener('change', () => {
          if (busy) return;
          const next = Math.min(max, Math.max(0, parseInt(input.value, 10) || 0));
          if (next === 0) { removeRow(); return; }
          input.value = next;
          change(line, next, row);
        });

        const remove = row.querySelector('[data-remove]');
        if (remove) remove.addEventListener('click', e => {
          e.preventDefault();
          if (busy) return;
          removeRow();
        });
      });

      // Order note: persist to the cart on blur via /cart/update.js. The textarea
      // (name/id="note") only submits with the native form (no-JS path); with JS on
      // there's no submit, so without this the typed note would be silently lost.
      // We don't re-render the section here — the value is already in the field and
      // a swap would steal focus / interrupt typing in adjacent fields.
      const note = cartRoot.querySelector('#note');
      if (note) {
        const status = cartRoot.querySelector('[data-note-status]');
        let lastSaved = note.value;
        let statusTimer = null;
        function flashSaved() {
          if (!status) return;
          status.classList.add('is-visible');
          if (statusTimer) clearTimeout(statusTimer);
          statusTimer = setTimeout(() => status.classList.remove('is-visible'), 2400);
        }
        note.addEventListener('blur', () => {
          const value = note.value;
          if (value === lastSaved) return; // nothing changed → skip the round-trip
          lastSaved = value;
          fetch(cartUrl + '/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: value })
          })
            .then(r => { if (r.ok) flashSaved(); else lastSaved = null; })
            .catch(() => { lastSaved = null; }); // force a retry on next blur if it failed
        });
      }
    }

    // The quick-shop modal (variant edit) renders a fresh cart section and hands
    // it back via this event; we own the swap + re-bind so all cart DOM logic
    // stays here. Registered on document so it survives root replacement.
    document.addEventListener('ultreia:cart:refresh', e => {
      const html = e.detail && e.detail.html;
      if (html) applySection(html);
    });
    document.addEventListener('ultreia:cart:add', refresh);
    // Changes made in the cart drawer (open on top of this page) re-render us too;
    // our own changes are tagged and already applied.
    document.addEventListener('ultreia:cart:change', e => {
      if (e.detail && e.detail.source === 'cart-page') return;
      if (e.detail && e.detail.source === 'cart-drawer') refresh();
    });

    bind(root);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-category-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-catcar]').forEach(function (section) {
      if (section.dataset.catcarInit) return;
      section.dataset.catcarInit = '1';

      var viewport = section.querySelector('.u-catcar__viewport');
      var track = section.querySelector('[data-catcar-track]');
      var prev = section.querySelector('[data-catcar-prev]');
      var next = section.querySelector('[data-catcar-next]');
      if (!viewport || !track) return;

      function updateArrows() {
        var atStart = track.scrollLeft <= 2;
        var atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
        if (prev) prev.toggleAttribute('data-hidden', atStart);
        if (next) next.toggleAttribute('data-hidden', atEnd);
      }

      function markOverflow() {
        if (track.scrollWidth > track.clientWidth + 4) {
          viewport.setAttribute('data-overflow', '');
        } else {
          viewport.removeAttribute('data-overflow');
        }
        updateArrows();
      }
      markOverflow();
      window.addEventListener('resize', markOverflow);
      track.addEventListener('scroll', updateArrows, { passive: true });

      function scrollByStep(dir) {
        var item = track.querySelector('.u-catcar__item');
        var step = item ? item.getBoundingClientRect().width + 22 : 160;
        track.scrollBy({ left: dir * step * 2, behavior: 'smooth' });
      }
      if (prev) prev.addEventListener('click', function () { scrollByStep(-1); });
      if (next) next.addEventListener('click', function () { scrollByStep(1); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-collection-hero"] && !Shopify.designMode) return;
  try {
    
  /* Auto-rotating background carousel: cross-fade through the slides on an
     interval, looping. Text/stats stay fixed on top. Pauses while the tab is
     hidden and respects reduced-motion (stays on the first slide). Scoped per
     <section data-collection-carousel> instance. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-collection-carousel]').forEach(function (section) {
      if (section.dataset.carouselInit) return;
      section.dataset.carouselInit = '1';

      var slides = section.querySelectorAll('.u-collection__slide');
      if (slides.length < 2 || reduce) return;

      // Hand control to JS: CSS now shows only the .is-active slide.
      var media = section.querySelector('.u-collection__media');
      slides[0].classList.add('is-active');
      if (media) media.setAttribute('data-carousel-ready', '');

      var delay = parseInt(section.getAttribute('data-rotate-ms'), 10) || 5000;
      var i = 0;
      var timer = null;

      function go() {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }
      function start() { if (!timer) timer = setInterval(go, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      // Pause when the tab/section isn't visible to save work.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-collection-teaser"] && !Shopify.designMode) return;
  try {
    
  /* Auto-rotating background carousel: cross-fade through the slides on an
     interval, looping. Text/stats/CTA stay fixed on top. Pauses while the tab is
     hidden and respects reduced-motion (stays on the first slide). Scoped per
     <section data-cteaser-carousel> instance. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-cteaser-carousel]').forEach(function (section) {
      if (section.dataset.carouselInit) return;
      section.dataset.carouselInit = '1';

      var slides = section.querySelectorAll('.u-cteaser__slide');
      if (slides.length < 2 || reduce) return;

      // Hand control to JS: CSS now shows only the .is-active slide.
      var media = section.querySelector('.u-cteaser__media');
      slides[0].classList.add('is-active');
      if (media) media.setAttribute('data-carousel-ready', '');

      var delay = parseInt(section.getAttribute('data-rotate-ms'), 10) || 5000;
      var i = 0;
      var timer = null;

      function go() {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }
      function start() { if (!timer) timer = setInterval(go, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      // Pause when the tab/section isn't visible to save work.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-footer"] && !Shopify.designMode) return;
  try {
    
  /* Mobile accordion: each column collapses below 600px. Columns are open on
     wider viewports and the heading is only interactive while the media query
     matches. The 600px here MUST match the @media breakpoint in the stylesheet
     above (Shopify doesn't render Liquid in these tags, so it can't be shared).
     Scoped per <footer.u-foot> instance. */
  (function () {
    document.querySelectorAll('.u-foot').forEach(function (foot) {
      if (foot.dataset.accInit) return;
      foot.dataset.accInit = '1';

      var mq = window.matchMedia('(max-width: 600px)');
      var columns = Array.prototype.slice.call(foot.querySelectorAll('.u-foot__col'));

      /* The accordion toggle is whichever element carries [data-acc]: the whole
         heading button (manual columns) or just the chevron button beside the
         title link (menu-driven columns, where the title navigates on its own). */
      function reset() {
        var open = !mq.matches;
        columns.forEach(function (col) {
          col.setAttribute('data-open', open);
          var t = col.querySelector('[data-acc]');
          if (t) t.setAttribute('aria-expanded', open);
        });
      }
      reset();

      columns.forEach(function (col) {
        var t = col.querySelector('[data-acc]');
        if (!t) return;
        t.addEventListener('click', function () {
          if (!mq.matches) return;
          var open = col.getAttribute('data-open') !== 'true';
          col.setAttribute('data-open', open);
          t.setAttribute('aria-expanded', open);
        });
      });

      if (mq.addEventListener) mq.addEventListener('change', reset);
      else mq.addListener(reset);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-header"] && !Shopify.designMode) return;
  try {
    
  /* Scoped per <header.u-bar> instance + its drawer. Three behaviours:
     1) desktop nav dropdowns (hover-open + click-pin, Esc / outside-click close)
     2) the mobile nav drawer (burger opens; scrim / close / Esc dismiss)
     3) accordion submenus inside the drawer
     Styling lives in this section's stylesheet (bar) + the drawer snippet; this
     only toggles state. */
  (function () {
    document.querySelectorAll('[data-ultreia-header]').forEach(function (bar) {
      if (bar.dataset.navInit) return;
      bar.dataset.navInit = '1';

      /* ---- Dropdown menus ------------------------------------------------ */
      var items = Array.prototype.slice.call(bar.querySelectorAll('.u-bar__navitem[data-haschild]'));
      var navRow = bar.querySelector('.u-bar__nav');
      var logo = bar.querySelector('.u-bar__logo');
      /* On the homepage's transparent header, the oversized/dropped wordmark
         (see .u-bar__logo's scroll-animation transform) sits centered right
         where a nearby trigger's panel (e.g. "Sobre nosotros") can open —
         geometrically check the CURRENTLY open panel against the logo's own
         box and mark the header only when they actually overlap, so the
         stylesheet fades the wordmark for exactly that clash and leaves it
         alone for every other item/scroll position. */
      function syncLogoClash() {
        if (!logo) return;
        var openItem = items.filter(function (i) { return i.classList.contains('is-open'); })[0];
        var clash = false;
        if (openItem) {
          var mega = openItem.querySelector(':scope > .u-bar__mega');
          if (mega) {
            var mRect = mega.getBoundingClientRect();
            var lRect = logo.getBoundingClientRect();
            clash = mRect.width > 0 && lRect.width > 0 && mRect.left < lRect.right && mRect.right > lRect.left;
          }
        }
        bar.classList.toggle('is-menu-open', clash);
      }
      function setOpen(it, open) {
        it.classList.toggle('is-open', open);
        var t = it.querySelector('[data-caret]');
        if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) it._pinned = false;
        syncLogoClash();
      }
      function closeAll(except) { items.forEach(function (it) { if (it !== except) setOpen(it, false); }); }
      /* Each item's panel opens directly under its own trigger (position:absolute,
         top:100%, left:0 — pure CSS default). If it would run off the right edge
         of the viewport, JS nudges it left by just enough pixels to fit — capped
         so it never also runs past the LEFT edge (for a panel wider than the
         viewport has room for on either side, e.g. Tienda/Mujer's wide four-list
         layout, it just sits flush against the edge with whatever overflow is
         unavoidable, rather than jumping to the opposite anchor). A binary
         left/right flip used to handle this (fine for the old narrow panels) but
         for a wide panel it could push most of the panel's own content off the
         left edge while only its rightmost sliver (e.g. the photo) stayed
         visible — this pixel-nudge approach keeps the whole panel as one visible
         block regardless of width. Always runs BEFORE setOpen so syncLogoClash
         reads the panel's final, aligned position. */
      function alignMega(it) {
        var mega = it.querySelector(':scope > .u-bar__mega');
        if (!mega) return;
        mega.style.left = '';
        var margin = 12;
        var rect = mega.getBoundingClientRect();
        // clientWidth, not innerWidth: innerWidth includes the vertical scrollbar,
        // which would let the panel hang a few px past the visible edge.
        var overflowRight = rect.right - (document.documentElement.clientWidth - margin);
        if (overflowRight > 0) {
          var maxShift = Math.max(0, rect.left - margin);
          var shift = Math.min(overflowRight, maxShift);
          if (shift > 0) mega.style.left = (-shift) + 'px';
        }
      }
      items.forEach(function (it) {
        var caret = it.querySelector('[data-caret]');
        it.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { closeAll(it); alignMega(it); setOpen(it, true); } });
        it.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse' && !it._pinned) setOpen(it, false); });
        /* The title is a real link (navigates to link.url); the caret toggles the dropdown. */
        if (caret) caret.addEventListener('click', function (e) {
          e.preventDefault();
          var open = !it.classList.contains('is-open');
          closeAll(it); if (open) alignMega(it); setOpen(it, open); it._pinned = open;
        });
        it.addEventListener('focusout', function (e) { if (!it.contains(e.relatedTarget)) setOpen(it, false); });
      });

      /* ---- Nested disclosures inside a mega panel (Tienda: Actividades /
         Marcas) — collapsed by default; a click on [data-mega-acc] reveals
         just that one list, independent of the panel's own open/close. */
      bar.querySelectorAll('[data-mega-acc]').forEach(function (btn) {
        var group = btn.closest('.u-bar__megacol--acc');
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var willOpen = group.getAttribute('data-open') !== 'true';
          group.setAttribute('data-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen);
        });
      });

      if (items.length) {
        document.addEventListener('click', function (e) { if (!e.target.closest('.u-bar__navitem')) closeAll(null); });
        document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(null); });
        /* Align every panel, closed ones too: a hidden panel (visibility, not
           display) still takes up layout, so one left under its trigger can hang
           past the right edge and give the page a horizontal scrollbar. Re-run
           once fonts/images settle and on every viewport change. */
        var alignAll = function () { items.forEach(alignMega); };
        alignAll();
        window.addEventListener('load', alignAll);
        window.addEventListener('resize', alignAll);
      }

      /* ---- Transparent → solid, driven by scroll progress ---------------- */
      /* For an overlay (transparent) header: instead of flipping at a threshold,
         publish a 0→1 progress as the page scrolls through the first stretch, and
         let CSS interpolate the bar background, text color and the logo
         size/offset continuously off `--scroll-p`. 1 == fully solid. */
      if (bar.classList.contains('u-bar--transparent') && bar.hasAttribute('data-scroll-animation')) {
        /* Distance over which the transition plays out (px of scroll). */
        var DIST = 460;
        /* easeOutQuint — matches the cubic-bezier(0.22, 1, 0.36, 1) feel, applied to
           the scroll progress so the morph is non-linear against scroll distance. */
        function ease(t) { return 1 - Math.pow(1 - t, 5); }
        var last = -1;
        function syncProgress() {
          var raw = Math.min(Math.max(window.scrollY / DIST, 0), 1);
          var p = ease(raw);
          /* round to cut redundant writes */
          p = Math.round(p * 1000) / 1000;
          if (p !== last) {
            last = p;
            bar.style.setProperty('--scroll-p', p);
          }
        }
        var ticking = false;
        function onScroll() {
          if (ticking) return;
          ticking = true;
          window.requestAnimationFrame(function () { syncProgress(); ticking = false; });
        }
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        syncProgress();
      }
    });

    /* ---- Drawers (nav + search + cart) ---------------------------------- */
    /* Three drawers can coexist: the nav drawer (opened by the burger /
       [data-drawer-open]), the search drawer (opened by the search icon /
       [data-search-open], marked [data-ultreia-search-drawer]) and the cart drawer
       (opened by the bag / [data-cart-open], marked [data-ultreia-cart-drawer]).
       Each trigger must open only its own drawer, so we resolve a single drawer per
       trigger type instead of wiring every trigger to every drawer. The nav drawer
       is whichever [data-ultreia-drawer] is neither the search nor the cart one. */
    var allDrawers = Array.prototype.slice.call(document.querySelectorAll('[data-ultreia-drawer]'));
    var searchDrawer = document.querySelector('[data-ultreia-search-drawer]');
    var cartDrawer = document.querySelector('[data-ultreia-cart-drawer]');
    var navDrawer = allDrawers.filter(function (d) { return d !== searchDrawer && d !== cartDrawer; })[0];

    function isOpen(drawer) { return drawer.getAttribute('data-open') === 'true'; }
    function openDrawer(drawer) {
      if (!drawer || isOpen(drawer)) return;
      /* Only one drawer at a time. */
      allDrawers.forEach(function (d) { if (d !== drawer) closeDrawer(d); });
      drawer.setAttribute('data-open', 'true');
      document.documentElement.style.overflow = 'hidden';
      var close = drawer.querySelector('.u-drawer__close');
      if (close) requestAnimationFrame(function () { close.focus(); });
    }
    function closeDrawer(drawer) {
      if (!drawer || !isOpen(drawer)) return;
      drawer.setAttribute('data-open', 'false');
      document.documentElement.style.overflow = '';
    }

    document.querySelectorAll('[data-drawer-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(navDrawer); });
    });
    document.querySelectorAll('[data-search-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) { e.preventDefault(); openDrawer(searchDrawer); });
    });
    /* Tapping the bag icon itself still just navigates to the cart page on mobile
       (≤680px, where the header collapses to the burger layout) — let the click
       fall through to its href instead of opening the drawer. The drawer's
       post-add-to-cart pop (right below) is NOT gated by this: adding a product
       opens the summary drawer on every screen size, same as desktop. */
    var cartDrawerMq = window.matchMedia('(min-width: 681px)');
    document.querySelectorAll('[data-cart-open]').forEach(function (btn) {
      btn.addEventListener('click', function (e) {
        if (!cartDrawerMq.matches) return; // mobile: navigate to the cart page
        e.preventDefault();
        openDrawer(cartDrawer);
      });
    });
    /* A drawer can ask to be opened programmatically (e.g. the cart drawer pops open
       after an add-to-cart) by dispatching ultreia:drawer:open on itself; the open
       engine lives here, so we honor it from here — on every screen size. */
    document.addEventListener('ultreia:drawer:open', function (e) {
      var d = e.target && e.target.closest ? e.target.closest('[data-ultreia-drawer]') : null;
      if (!d) return;
      openDrawer(d);
    });

    allDrawers.forEach(function (drawer) {
      if (drawer.dataset.drawerInit) return;
      drawer.dataset.drawerInit = '1';

      drawer.querySelectorAll('[data-drawer-close]').forEach(function (el) {
        el.addEventListener('click', function () { closeDrawer(drawer); });
      });

      /* Accordion submenus (nav drawer only, but harmless elsewhere). */
      drawer.querySelectorAll('[data-drawer-acc]').forEach(function (btn) {
        var row = btn.closest('.u-drawer__row');
        btn.addEventListener('click', function () {
          var willOpen = row.getAttribute('data-open') !== 'true';
          row.setAttribute('data-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen);
        });
      });

      /* Nested disclosures inside a row's sub-panel (Tienda: Actividades /
         Marcas) — collapsed by default; a tap on [data-drawer-subacc] opens
         just that one list, independent of the parent row's own accordion. */
      drawer.querySelectorAll('[data-drawer-subacc]').forEach(function (btn) {
        var group = btn.closest('.u-drawer__subgroup--acc');
        btn.addEventListener('click', function (e) {
          e.stopPropagation();
          var willOpen = group.getAttribute('data-open') !== 'true';
          group.setAttribute('data-open', willOpen);
          btn.setAttribute('aria-expanded', willOpen);
        });
      });

      /* "Los menús" (.u-mnav in ultreia-nav-drawer) — three-level accordion.
         Opening an item closes its open siblings (and closing an item closes
         everything inside it). While panels above collapse, the tapped button
         would slide up under the finger — so for the length of the animation
         the scroll position is nudged every frame to keep it steady, then, if
         the newly opened panel runs past the bottom, the drawer glides down
         just enough to show it (never further than putting the button on top). */
      var mnavScroller = drawer.querySelector('.u-drawer__body');
      if (mnavScroller && drawer.querySelector('.u-mnav')) mnavScroller.style.overflowAnchor = 'none';
      function setMnav(item, open) {
        item.setAttribute('data-open', open ? 'true' : 'false');
        var t = item.querySelector(':scope > [data-mnav-toggle]');
        if (t) t.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (!open) {
          item.querySelectorAll('[data-mnav-item][data-open="true"]').forEach(function (inner) { setMnav(inner, false); });
        }
      }
      drawer.querySelectorAll('[data-mnav-toggle]').forEach(function (btn) {
        var item = btn.closest('[data-mnav-item]');
        btn.addEventListener('click', function () {
          var willOpen = item.getAttribute('data-open') !== 'true';
          var anchor = btn.getBoundingClientRect().top;
          if (willOpen) {
            Array.prototype.forEach.call(item.parentElement.children, function (sib) {
              if (sib !== item && sib.matches('[data-mnav-item][data-open="true"]')) setMnav(sib, false);
            });
          }
          setMnav(item, willOpen);
          if (!mnavScroller) return;
          var start = performance.now();
          (function steady(now) {
            var drift = btn.getBoundingClientRect().top - anchor;
            if (Math.abs(drift) > .5) mnavScroller.scrollTop += drift;
            if (now - start < 420) { requestAnimationFrame(steady); return; }
            if (!willOpen) return;
            var box = mnavScroller.getBoundingClientRect();
            var over = item.getBoundingClientRect().bottom - (box.bottom - 12);
            var room = btn.getBoundingClientRect().top - (box.top + 12);
            var by = Math.min(over, room);
            if (by > 0) mnavScroller.scrollBy({ top: by, behavior: 'smooth' });
          })(start);
        });
      });
    });

    document.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      allDrawers.forEach(function (d) { closeDrawer(d); });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-kits-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(section) {
      if (section.dataset.kitcarInit) return;
      section.dataset.kitcarInit = '1';
      var viewport = section.querySelector('.u-kitcar__viewport');
      var track = section.querySelector('[data-kitcar-track]');
      var prev = section.querySelector('[data-kitcar-prev]');
      var next = section.querySelector('[data-kitcar-next]');
      if (!viewport || !track) return;

      function updateArrows() {
        prev.toggleAttribute('data-hidden', track.scrollLeft <= 2);
        next.toggleAttribute('data-hidden', track.scrollLeft + track.clientWidth >= track.scrollWidth - 2);
      }
      function markOverflow() {
        viewport.toggleAttribute('data-overflow', track.scrollWidth > track.clientWidth + 4);
        updateArrows();
      }
      markOverflow();
      window.addEventListener('resize', markOverflow);
      track.addEventListener('scroll', updateArrows, { passive: true });

      function step(dir) {
        var item = track.querySelector('.u-kitcar__item');
        var w = item ? item.getBoundingClientRect().width + 16 : 300;
        track.scrollBy({ left: dir * w, behavior: 'smooth' });
      }
      prev.addEventListener('click', function () { step(-1); });
      next.addEventListener('click', function () { step(1); });
    }
    function initAll() { document.querySelectorAll('[data-kitcar]').forEach(init); }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-magazine-hero"] && !Shopify.designMode) return;
  try {
    
  /* Magazine Hero carousel — autoplay crossfade between [data-mag-slide]
     photos, with [data-mag-dot] buttons to jump directly (and restart the
     timer). No-op when there's only one slide (or none) — the section just
     shows whatever ultreia-magazine-hero.liquid rendered as the fallback. */
  (function () {
    document.querySelectorAll('[data-mag-carousel]').forEach(function (root) {
      if (root.dataset.magInit) return;
      root.dataset.magInit = '1';

      var slides = root.querySelectorAll('[data-mag-slide]');
      if (slides.length < 2) return;

      var section = root.closest('.u-mag-hero');
      var dots = section ? section.querySelectorAll('[data-mag-dot]') : [];
      var idx = 0;
      var INTERVAL = 5500;

      function show(i) {
        idx = i;
        slides.forEach(function (s, si) { s.classList.toggle('is-current', si === idx); });
        dots.forEach(function (d, di) { d.classList.toggle('is-current', di === idx); });
      }

      var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var timer = null;
      function restart() {
        clearInterval(timer);
        if (reduced) return;
        timer = setInterval(function () { show((idx + 1) % slides.length); }, INTERVAL);
      }

      dots.forEach(function (d, i) {
        d.addEventListener('click', function () {
          show(i);
          restart();
        });
      });

      restart();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-main-page-hero"] && !Shopify.designMode) return;
  try {
    
  /* Auto-rotating background carousel: cross-fade through the slides on an
     interval, looping. Text stays fixed on top. Pauses while the tab is hidden
     and respects reduced-motion (stays on the first slide). Scoped per
     <section data-mphero-carousel> instance. */
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-mphero-carousel]').forEach(function (section) {
      if (section.dataset.carouselInit) return;
      section.dataset.carouselInit = '1';

      var slides = section.querySelectorAll('.u-mphero__slide');
      if (slides.length < 2 || reduce) return;

      // Hand control to JS: CSS now shows only the .is-active slide.
      var media = section.querySelector('.u-mphero__media');
      slides[0].classList.add('is-active');
      if (media) media.setAttribute('data-carousel-ready', '');

      var delay = parseInt(section.getAttribute('data-rotate-ms'), 10) || 5000;
      var i = 0;
      var timer = null;

      function go() {
        slides[i].classList.remove('is-active');
        i = (i + 1) % slides.length;
        slides[i].classList.add('is-active');
      }
      function start() { if (!timer) timer = setInterval(go, delay); }
      function stop() { if (timer) { clearInterval(timer); timer = null; } }

      // Pause when the tab/section isn't visible to save work.
      document.addEventListener('visibilitychange', function () {
        if (document.hidden) { stop(); } else { start(); }
      });
      start();
    });

    // Background video: force it to actually start, and keep retrying.
    // Mobile Safari (mainly iOS Low Power Mode / slow connections) sometimes
    // ignores the autoplay attribute and shows a native "tap to play" icon
    // instead — this makes sure playback starts the moment it's able to,
    // without the visitor ever needing to tap the video itself.
    var heroVideo = document.querySelector('.u-mphero__video');
    if (heroVideo) {
      var tryPlayHeroVideo = function () {
        var playPromise = heroVideo.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {});
        }
      };
      tryPlayHeroVideo();
      heroVideo.addEventListener('loadeddata', tryPlayHeroVideo);
      heroVideo.addEventListener('canplay', tryPlayHeroVideo);
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) tryPlayHeroVideo();
      });
      // A single touch/click anywhere on the page (not just the video) is
      // enough to satisfy the OS and let playback begin.
      document.addEventListener('touchstart', tryPlayHeroVideo, { once: true, passive: true });
      document.addEventListener('click', tryPlayHeroVideo, { once: true });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-newsletter-popup"] && !Shopify.designMode) return;
  try {
    
  (function () {
    // {% javascript %} runs once per section type, so query all instances.
    document.querySelectorAll('[data-newspop]').forEach(setup);

    function setup(el) {
      var key = el.getAttribute('data-storage-key');
      var form = el.querySelector('.u-newspop__form');
      var succeeded = !!el.querySelector('.u-newspop__success');

      // A successful native customer submit reloads the page with our hash and
      // renders the success markup. Show the modal one last time, then flag it
      // dismissed so it never returns.
      if (succeeded && location.hash.indexOf('newspop-') !== -1) {
        open(el);
        remember(key);
        wireClose(el, key);
        return;
      }

      // Point the reloaded URL at this section so the branch above can detect a
      // completed submit (the native form has no client-side success event).
      if (form) {
        form.setAttribute('action', form.getAttribute('action') || (location.pathname));
        form.addEventListener('submit', function () {
          try { form.action = form.action.split('#')[0] + '#newspop-' + el.id; } catch (e) {}
        });
      }

      wireClose(el, key);

      if (dismissed(key)) return;

      var minDelay = (parseFloat(el.getAttribute('data-min-delay')) || 0) * 1000;
      var pct = parseFloat(el.getAttribute('data-scroll-percent')) || 40;
      var exitIntent = el.getAttribute('data-exit-intent') === 'true';
      var ready = false;
      var opened = false;

      setTimeout(function () { ready = true; }, minDelay);

      function trigger() {
        if (opened || !ready || dismissed(key)) return;
        opened = true;
        cleanup();
        open(el);
        remember(key);
      }

      function onScroll() {
        var h = document.documentElement;
        var scrolled = (h.scrollTop || document.body.scrollTop);
        var max = (h.scrollHeight - h.clientHeight) || 1;
        if ((scrolled / max) * 100 >= pct) trigger();
      }
      function onLeave(e) {
        if (e.clientY <= 0) trigger();
      }
      function cleanup() {
        window.removeEventListener('scroll', onScroll);
        if (exitIntent) document.removeEventListener('mouseout', onLeave);
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      if (exitIntent && window.matchMedia('(min-width: 700px)').matches) {
        document.addEventListener('mouseout', onLeave);
      }
    }

    function open(el) {
      lockScroll(true);
      el.hidden = false;
      // Next frame so the CSS transition runs from the hidden state.
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { el.classList.add('is-open'); });
      });
      // Focus the close button, not the email input: autofocusing the input
      // pops the on-screen keyboard on mobile the instant the modal opens,
      // which shifts the viewport mid-animation and can make a tap aimed at
      // the X land somewhere else (reported as the popup "getting stuck").
      var focusTarget = el.querySelector('.u-newspop__x');
      if (focusTarget) { try { focusTarget.focus({ preventScroll: true }); } catch (e) { focusTarget.focus(); } }
    }

    function close(el) {
      // If the visitor had tapped into the email field, drop focus first so
      // the on-screen keyboard starts dismissing right away instead of
      // fighting the close transition.
      var active = document.activeElement;
      if (active && el.contains(active) && typeof active.blur === 'function') active.blur();
      el.classList.remove('is-open');
      lockScroll(false);
      setTimeout(function () { el.hidden = true; }, 380);
    }

    // Keeps the page behind the modal from scrolling while it's open, so the
    // close transition isn't competing with background motion.
    function lockScroll(locked) {
      document.documentElement.classList.toggle('u-newspop-locked', locked);
    }

    function wireClose(el, key) {
      el.querySelectorAll('[data-newspop-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { remember(key); close(el); });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && !el.hidden) { remember(key); close(el); }
      });
    }

    // The popup reappears once every 24 hours: instead of a permanent flag,
    // we store the timestamp it was last dismissed and compare against it.
    var REAPPEAR_MS = 24 * 60 * 60 * 1000;
    function dismissed(key) {
      try {
        var stamp = parseInt(localStorage.getItem(key), 10);
        return !isNaN(stamp) && (Date.now() - stamp) < REAPPEAR_MS;
      } catch (e) { return false; }
    }
    function remember(key) {
      try { localStorage.setItem(key, String(Date.now())); } catch (e) {}
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-product"] && !Shopify.designMode) return;
  try {
    
  /* ULTREIA PDP runtime — scoped per [data-pdp]. Three jobs:
       1. Gallery: thumbnails / variant images swap the current stage slide.
       2. Variant picker: resolve option selections → variant (same logic as the
          quick-shop modal's findVariant/valueIsAvailable), keep the hidden id,
          the price, the compare price, the discount badge and the CTA in sync.
       3. Add to cart: AJAX POST /cart/add.js, then bump .u-bag__count and
          dispatch `ultreia:cart:add` — matching the card / quick-shop. Falls
          back to a native form submit if anything goes wrong.
  */
  (function () {
    document.querySelectorAll('[data-pdp]').forEach(function (root) {
      if (root.dataset.pdpInit) return;
      root.dataset.pdpInit = '1';

      // Localized strings rendered onto the root in the markup (Liquid runs
      // there but not inside a static javascript tag).
      var I18N = {};
      try { I18N = JSON.parse(root.getAttribute('data-i18n') || '{}'); } catch (e) {}

      // ---- Collapsible description --------------------------------------
      // Clamp the description only when it actually overflows the clamp
      // height; otherwise leave it fully visible and hide the toggle.
      (function () {
        var wrap = root.querySelector('[data-pdp-desc]');
        if (!wrap) return;
        var body = wrap.querySelector('[data-pdp-desc-body]');
        var btn = wrap.querySelector('[data-pdp-desc-toggle]');
        var more = wrap.querySelector('[data-pdp-desc-more]');
        var less = wrap.querySelector('[data-pdp-desc-less]');
        if (!body || !btn) return;

        function measure() {
          // Apply the clamp, then compare the visible (clientHeight) box
          // against the full content (scrollHeight). scrollHeight ignores
          // max-height/overflow, so the difference reveals true overflow.
          wrap.classList.remove('is-expanded');
          wrap.classList.add('is-clamped');
          var overflows = body.scrollHeight > body.clientHeight + 2;
          if (!overflows) {
            wrap.classList.remove('is-clamped');
            btn.hidden = true;
          } else {
            btn.hidden = false;
          }
        }

        btn.addEventListener('click', function () {
          var expanded = wrap.classList.toggle('is-expanded');
          wrap.classList.toggle('is-clamped', !expanded);
          btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
          if (more) more.hidden = expanded;
          if (less) less.hidden = !expanded;
        });

        measure();
        // Re-measure once webfonts settle — line wrapping changes the height.
        if (document.fonts && document.fonts.ready) {
          document.fonts.ready.then(function () {
            if (!wrap.classList.contains('is-expanded')) measure();
          });
        }
        if (window.matchMedia) {
          var rm = window.matchMedia('(max-width: 680px)');
          (rm.addEventListener ? rm.addEventListener.bind(rm, 'change') : rm.addListener.bind(rm))(function () {
            if (!wrap.classList.contains('is-expanded')) measure();
          });
        }
      })();

      var dataEl = root.querySelector('[data-pdp-variants]');
      if (!dataEl) return;
      var data;
      try { data = JSON.parse(dataEl.textContent); } catch (e) { return; }

      // ---- Cart-aware inventory cap --------------------------------------
      // How many of each variant are already in the cart, keyed by variant id.
      // Lets us disable "Agregar" once cart qty reaches a tracked variant's
      // stock — instead of letting the shopper click into a server error.
      var cartQtyByVariant = {};
      function setCartQty(cart) {
        cartQtyByVariant = {};
        ((cart && cart.items) || []).forEach(function (it) {
          cartQtyByVariant[it.variant_id] = (cartQtyByVariant[it.variant_id] || 0) + it.quantity;
        });
      }
      function loadCartQty() {
        if (!window.fetch) return Promise.resolve();
        return fetch('/cart.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(setCartQty)
          .catch(function () { /* leave the map empty — cap simply won't apply */ });
      }
      // True when adding one more of this variant would exceed its stock.
      function atStockCap(v) {
        if (!v || !v.tracked) return false;
        return (cartQtyByVariant[v.id] || 0) >= v.inventory;
      }

      // ---- Gallery -------------------------------------------------------
      var slides = root.querySelectorAll('.u-pdp__img');
      var thumbs = root.querySelectorAll('[data-pdp-thumb]');
      function showSlide(idx) {
        slides.forEach(function (s) {
          s.classList.toggle('is-current', s.getAttribute('data-pdp-slide') === String(idx));
        });
        thumbs.forEach(function (t) {
          var on = t.getAttribute('data-pdp-thumb') === String(idx);
          t.classList.toggle('is-current', on);
          t.setAttribute('aria-selected', on ? 'true' : 'false');
        });
        var count = root.querySelector('[data-pdp-count]');
        if (count) count.textContent = parseInt(idx, 10) + 1;
      }
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { showSlide(t.getAttribute('data-pdp-thumb')); });
      });

      // ---- Swipe (mobile carousel) ----------------------------------------
      // Lets a shopper flick left/right directly on the photo to move through
      // the gallery — same crossfade showSlide() the thumbnails/dots use, just
      // triggered by a touch gesture instead of a tap. Vertical/short gestures
      // are ignored so page scroll and simple taps (e.g. the zoom button) keep
      // working; listeners are passive (no preventDefault) for the same reason.
      (function () {
        var stage = root.querySelector('.u-pdp__stage');
        if (!stage || slides.length < 2) return;
        var startX = 0, startY = 0, tracking = false;
        stage.addEventListener('touchstart', function (e) {
          if (e.touches.length !== 1) { tracking = false; return; }
          startX = e.touches[0].clientX;
          startY = e.touches[0].clientY;
          tracking = true;
        }, { passive: true });
        stage.addEventListener('touchend', function (e) {
          if (!tracking) return;
          tracking = false;
          var touch = e.changedTouches[0];
          var dx = touch.clientX - startX;
          var dy = touch.clientY - startY;
          if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
          var current = root.querySelector('.u-pdp__img.is-current');
          var idx = current ? Number(current.getAttribute('data-pdp-slide')) : 0;
          var last = slides.length - 1;
          idx = dx < 0 ? Math.min(idx + 1, last) : Math.max(idx - 1, 0);
          showSlide(idx);
        }, { passive: true });
      })();

      // Map a variant's featured image (by src, minus the width query) to a slide
      // index, so picking a color jumps the gallery to that color's photo.
      var slideSrcByIndex = {};
      slides.forEach(function (s) {
        var src = (s.getAttribute('src') || '').split('?')[0];
        slideSrcByIndex[s.getAttribute('data-pdp-slide')] = src;
      });
      function slideForImage(imgUrl) {
        if (!imgUrl) return null;
        var base = imgUrl.split('?')[0];
        var found = null;
        Object.keys(slideSrcByIndex).forEach(function (i) {
          if (found == null && slideSrcByIndex[i] === base) found = i;
        });
        return found;
      }

      // ---- Zoom (magnifying glass) ----------------------------------------
      // Fullscreen viewer. Desktop pans a magnified image under the cursor;
      // touch supports pinch-to-zoom, one-finger drag to pan (once zoomed) and
      // a double-tap to toggle. Closes via the × button, backdrop click or Esc.
      (function () {
        var openBtn = root.querySelector('[data-pdp-zoom-open]');
        var overlay = root.querySelector('[data-pdp-zoom-overlay]');
        if (!openBtn || !overlay) return;
        // Reparent to <body>: `.u-pdp__media` is `position: sticky`, and some
        // browsers (notably iOS/desktop Safari) mis-render a `position: fixed`
        // descendant of a sticky ancestor — it can end up clipped/confined to
        // the sticky box instead of covering the viewport, which broke the
        // overlay (content showing through, close button unreachable).
        // Moving it to <body> guarantees `fixed` is always viewport-relative.
        document.body.appendChild(overlay);
        var backdrop = overlay.querySelector('[data-pdp-zoom-backdrop]');
        var closeBtn = overlay.querySelector('[data-pdp-zoom-close]');
        var prevBtn = overlay.querySelector('[data-pdp-zoom-prev]');
        var nextBtn = overlay.querySelector('[data-pdp-zoom-next]');
        var viewport = overlay.querySelector('[data-pdp-zoom-viewport]');
        var zoomImg = overlay.querySelector('[data-pdp-zoom-img]');

        var sources = [];
        root.querySelectorAll('.u-pdp__img').forEach(function (s) {
          sources[Number(s.getAttribute('data-pdp-slide'))] = s.getAttribute('data-pdp-zoom-src') || s.getAttribute('src');
        });

        var index = 0;
        var scale = 1, panX = 0, panY = 0;

        function applyTransform() {
          zoomImg.style.transform = 'translate(' + panX + 'px, ' + panY + 'px) scale(' + scale + ')';
        }
        function resetTransform() {
          scale = 1; panX = 0; panY = 0;
          zoomImg.style.transform = '';
          zoomImg.style.transformOrigin = '';
        }
        function show(i) {
          if (!sources.length) return;
          if (i < 0) i = sources.length - 1;
          if (i >= sources.length) i = 0;
          index = i;
          zoomImg.src = sources[i];
          resetTransform();
        }
        function open() {
          var current = root.querySelector('.u-pdp__img.is-current');
          show(current ? Number(current.getAttribute('data-pdp-slide')) : 0);
          overlay.hidden = false;
          document.documentElement.style.overflow = 'hidden';
        }
        function close() {
          overlay.hidden = true;
          document.documentElement.style.overflow = '';
          resetTransform();
        }

        openBtn.addEventListener('click', open);
        closeBtn.addEventListener('click', close);
        if (backdrop) backdrop.addEventListener('click', close);
        document.addEventListener('keydown', function (e) {
          if (e.key === 'Escape' && !overlay.hidden) close();
        });
        if (prevBtn) prevBtn.addEventListener('click', function () { show(index - 1); });
        if (nextBtn) nextBtn.addEventListener('click', function () { show(index + 1); });

        // Desktop / mouse: the image magnifies and pans under the cursor.
        var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (canHover) {
          viewport.addEventListener('mousemove', function (e) {
            var rect = viewport.getBoundingClientRect();
            var x = ((e.clientX - rect.left) / rect.width) * 100;
            var y = ((e.clientY - rect.top) / rect.height) * 100;
            zoomImg.style.transformOrigin = x + '% ' + y + '%';
            zoomImg.style.transform = 'scale(2.4)';
          });
          viewport.addEventListener('mouseleave', function () {
            zoomImg.style.transform = 'scale(1)';
          });
        }

        // Touch: pinch to zoom, one-finger drag to pan once zoomed, double-tap
        // to toggle between fit and ~2.4x.
        var pinchStartDist = 0, pinchStartScale = 1;
        var panStartX = 0, panStartY = 0, panning = false;
        var lastTap = 0;

        function touchDist(touches) {
          var dx = touches[0].clientX - touches[1].clientX;
          var dy = touches[0].clientY - touches[1].clientY;
          return Math.sqrt(dx * dx + dy * dy);
        }

        viewport.addEventListener('touchstart', function (e) {
          if (e.touches.length === 2) {
            pinchStartDist = touchDist(e.touches);
            pinchStartScale = scale;
          } else if (e.touches.length === 1) {
            if (scale > 1) {
              panning = true;
              panStartX = e.touches[0].clientX - panX;
              panStartY = e.touches[0].clientY - panY;
            }
            var now = Date.now();
            if (now - lastTap < 300) {
              scale = scale > 1 ? 1 : 2.4;
              panX = 0; panY = 0;
              applyTransform();
            }
            lastTap = now;
          }
        }, { passive: true });

        viewport.addEventListener('touchmove', function (e) {
          if (e.touches.length === 2) {
            e.preventDefault();
            var dist = touchDist(e.touches);
            scale = Math.min(Math.max(pinchStartScale * (dist / pinchStartDist), 1), 4);
            applyTransform();
          } else if (e.touches.length === 1 && panning) {
            e.preventDefault();
            panX = e.touches[0].clientX - panStartX;
            panY = e.touches[0].clientY - panStartY;
            applyTransform();
          }
        }, { passive: false });

        viewport.addEventListener('touchend', function (e) {
          if (e.touches.length === 0) panning = false;
        });
      })();

      // ---- Hover lens (desktop) -------------------------------------------
      // Passing the cursor over the photo — no click needed — shows a small
      // round lens that follows the mouse with a modest zoom of exactly what's
      // underneath it. It's a self-contained visual effect: never navigates
      // anywhere, and is skipped entirely on touch devices (they already have
      // the pinch/pan zoom in the fullscreen viewer above).
      (function () {
        var canHover = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;
        if (!canHover) return;
        var stage = root.querySelector('.u-pdp__stage');
        var lens = root.querySelector('[data-pdp-lens]');
        var lensImg = root.querySelector('[data-pdp-lens-img]');
        var zoomBtn = root.querySelector('[data-pdp-zoom-open]');
        if (!stage || !lens || !lensImg) return;

        var LENS = 170; // px — keep in sync with the .u-pdp__lens CSS size.
        var ZOOM = 1.8; // modest magnification, not the fullscreen viewer's.

        function currentSrc() {
          var cur = stage.querySelector('.u-pdp__img.is-current');
          return cur ? (cur.getAttribute('data-pdp-zoom-src') || cur.getAttribute('src')) : null;
        }

        // True while the cursor is over the zoom button itself (plus a small
        // margin) — the lens steps aside there so the button stays visible
        // and clickable with its normal pointer cursor.
        function overButton(e) {
          if (!zoomBtn) return false;
          var r = zoomBtn.getBoundingClientRect();
          var pad = 6;
          return e.clientX >= r.left - pad && e.clientX <= r.right + pad &&
                 e.clientY >= r.top - pad && e.clientY <= r.bottom + pad;
        }

        function move(e) {
          if (overButton(e)) { lens.classList.remove('is-active'); return; }

          var src = currentSrc();
          if (!src) { lens.classList.remove('is-active'); return; }
          if (lensImg.getAttribute('src') !== src) lensImg.src = src;
          lens.classList.add('is-active');

          var rect = stage.getBoundingClientRect();
          var relX = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
          var relY = Math.min(Math.max((e.clientY - rect.top) / rect.height, 0), 1);

          // Scale the SAME box proportions as the stage (so object-fit: cover
          // crops it identically, just bigger), then place it so the point
          // under the cursor lands exactly at the lens's own center.
          var w = rect.width * ZOOM;
          var h = rect.height * ZOOM;
          lensImg.style.width = w + 'px';
          lensImg.style.height = h + 'px';
          lensImg.style.left = (LENS / 2 - relX * w) + 'px';
          lensImg.style.top = (LENS / 2 - relY * h) + 'px';

          lens.style.left = (e.clientX - LENS / 2) + 'px';
          lens.style.top = (e.clientY - LENS / 2) + 'px';
        }

        stage.addEventListener('mouseenter', function (e) {
          if (!currentSrc()) return;
          lens.classList.add('is-active');
          move(e);
        });
        stage.addEventListener('mousemove', move);
        stage.addEventListener('mouseleave', function () {
          lens.classList.remove('is-active');
        });
      })();

      // ---- Variant picker ------------------------------------------------
      var hiddenId = root.querySelector('[data-pdp-variant-id]');
      var priceEl = root.querySelector('[data-pdp-price]');
      var compareEl = root.querySelector('[data-pdp-compare]');
      var discountEl = root.querySelector('.u-pdp__discount');
      var addBtn = root.querySelector('[data-pdp-add]');
      var addLabel = root.querySelector('[data-pdp-add-label]');
      // The canonical add label lives on a data attribute (rendered regardless of
      // the initial sold-out state), so transient states ("Agregando…", "Máximo en
      // mochila", "Agotado") never get mistaken for the default. refresh() restores
      // it when the selected variant is addable again.
      var defaultAddLabel = (addBtn && addBtn.getAttribute('data-add-label')) || I18N.add;
      var buyBtn = root.querySelector('[data-pdp-buy-now]');
      var buyLabel = root.querySelector('[data-pdp-buy-now-label]');
      var defaultBuyLabel = (buyBtn && buyBtn.getAttribute('data-buy-now-label')) || (buyLabel && buyLabel.textContent) || '';

      var selected = {};
      root.querySelectorAll('[data-pdp-opt]').forEach(function (opt) {
        var pos = Number(opt.getAttribute('data-pdp-opt-pos'));
        var sel = opt.querySelector('[data-pdp-value].is-selected');
        if (sel) selected[pos] = sel.getAttribute('data-pdp-value');
      });

      function findVariant() {
        // No pickers rendered (default / single-variant product): there's nothing
        // to resolve, so the only variant is the one to use.
        if (Object.keys(selected).length === 0) return data.variants[0];
        var positions = data.options.map(function (o) { return o.position; });
        return data.variants.find(function (v) {
          return positions.every(function (pos, i) { return v.options[i] === selected[pos]; });
        });
      }
      function valueIsAvailable(pos, value) {
        var positions = data.options.map(function (o) { return o.position; });
        return data.variants.some(function (v) {
          if (!v.available) return false;
          return positions.every(function (p, i) {
            if (p === pos) return v.options[i] === value;
            return selected[p] == null || v.options[i] === selected[p];
          });
        });
      }
      function refreshChoices() {
        root.querySelectorAll('[data-pdp-opt]').forEach(function (opt) {
          var pos = Number(opt.getAttribute('data-pdp-opt-pos'));
          opt.querySelectorAll('[data-pdp-value]').forEach(function (c) {
            var ok = valueIsAvailable(pos, c.getAttribute('data-pdp-value'));
            c.classList.toggle('is-unavailable', !ok);
            c.setAttribute('aria-disabled', ok ? 'false' : 'true');
          });
        });
      }
      function setDiscount(v) {
        if (!discountEl) return;
        if (v && v.compare_at > v.price) {
          var pct = Math.round((v.compare_at - v.price) * 100 / v.compare_at);
          discountEl.textContent = '-' + pct + '%';
        } else {
          discountEl.textContent = '';
        }
      }
      function refresh() {
        refreshChoices();
        var v = findVariant();
        if (v) {
          if (hiddenId) hiddenId.value = v.id;
          if (priceEl) {
            priceEl.textContent = v.price_formatted;
            priceEl.classList.toggle('is-sale', v.compare_at > v.price);
          }
          if (compareEl) {
            if (v.compare_at > v.price && v.compare_at_formatted) {
              compareEl.textContent = v.compare_at_formatted;
              compareEl.hidden = false;
            } else {
              compareEl.hidden = true;
            }
          }
          setDiscount(v);
          // Jump the gallery to this variant's image if it has one.
          var idx = slideForImage(v.featured_image);
          if (idx != null) showSlide(idx);
        }
        if (addBtn) {
          if (!v || !v.available) {
            addBtn.setAttribute('disabled', '');
            if (addLabel) addLabel.textContent = v ? I18N.soldOut : I18N.noSelection;
          } else if (atStockCap(v)) {
            // In stock, but the cart already holds every available unit.
            addBtn.setAttribute('disabled', '');
            if (addLabel) addLabel.textContent = I18N.maxInBag;
          } else {
            addBtn.removeAttribute('disabled');
            if (addLabel) addLabel.textContent = defaultAddLabel;
          }
        }
        if (buyBtn) {
          if (!v || !v.available || atStockCap(v)) {
            buyBtn.setAttribute('disabled', '');
          } else {
            buyBtn.removeAttribute('disabled');
          }
          if (buyLabel && !buyBtn.hasAttribute('aria-busy')) buyLabel.textContent = defaultBuyLabel;
        }
      }

      root.querySelectorAll('[data-pdp-opt]').forEach(function (opt) {
        var pos = Number(opt.getAttribute('data-pdp-opt-pos'));
        opt.addEventListener('click', function (e) {
          var choice = e.target.closest('[data-pdp-value]');
          if (!choice) return;
          if (choice.getAttribute('aria-disabled') === 'true') return;
          selected[pos] = choice.getAttribute('data-pdp-value');
          opt.querySelectorAll('[data-pdp-value]').forEach(function (c) {
            var on = c === choice;
            c.classList.toggle('is-selected', on);
            c.setAttribute('aria-checked', on ? 'true' : 'false');
          });
          var valEl = opt.querySelector('[data-pdp-opt-value]');
          if (valEl) valEl.textContent = selected[pos];
          refresh();
        });
      });

      // ---- Add to cart (AJAX, with native-submit fallback) ---------------
      function bumpBagCount(count) {
        var el = document.querySelector('.u-bag__count');
        if (!el) return;
        el.textContent = count;
        el.setAttribute('data-count', count);
      }
      var form = root.querySelector('[data-pdp-form]');
      if (form && addBtn) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return; // let the browser submit natively
          e.preventDefault();
          var id = hiddenId && hiddenId.value;
          if (!id || addBtn.hasAttribute('disabled')) return;
          addBtn.setAttribute('aria-busy', 'true');
          var prevLabel = addLabel ? addLabel.textContent : '';
          if (addLabel) addLabel.textContent = I18N.adding;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
            .then(function (line) {
              return fetch('/cart.js', { headers: { Accept: 'application/json' } })
                .then(function (r) { return r.json(); })
                .then(function (cart) {
                  bumpBagCount(cart.item_count);
                  // Keep the inventory cap in sync so the button disables once the
                  // cart reaches stock — without waiting for a page reload.
                  setCartQty(cart);
                  document.dispatchEvent(new CustomEvent('ultreia:cart:add', { detail: { cart: cart, line: line } }));
                });
            })
            .then(function () {
              if (addLabel) addLabel.textContent = I18N.added;
              setTimeout(function () {
                addBtn.removeAttribute('aria-busy');
                if (addLabel) addLabel.textContent = prevLabel;
                refresh();
              }, 1500);
            })
            .catch(function () {
              addBtn.removeAttribute('aria-busy');
              if (addLabel) addLabel.textContent = I18N.errorRetry;
              setTimeout(function () { if (addLabel) addLabel.textContent = prevLabel; refresh(); }, 1800);
            });
        });
      }

      // ---- Buy now (add to cart, then straight to checkout) --------------
      if (buyBtn) {
        buyBtn.addEventListener('click', function () {
          var id = hiddenId && hiddenId.value;
          if (!id || buyBtn.hasAttribute('disabled')) return;
          buyBtn.setAttribute('aria-busy', 'true');
          if (buyLabel) buyLabel.textContent = I18N.redirecting || defaultBuyLabel;

          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
          })
            .then(function (r) { if (!r.ok) return r.json().then(function (j) { throw j; }); return r.json(); })
            .then(function () {
              window.location.href = '/checkout';
            })
            .catch(function () {
              buyBtn.removeAttribute('aria-busy');
              if (buyLabel) buyLabel.textContent = I18N.errorRetry;
              setTimeout(function () { if (buyLabel) buyLabel.textContent = defaultBuyLabel; refresh(); }, 1800);
            });
        });
      }

      // Initial paint from server state, then reconcile the inventory cap once we
      // know what's already in the cart (so a returning shopper sees the button
      // already capped where appropriate).
      refresh();
      loadCartQty().then(refresh);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ultreia-travel-agencies"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var trips = window.ULT_TRIPS || {};
    var today = new Date().toISOString().slice(0, 10);

    var byName = Object.keys(trips).map(function (name) {
      return Object.assign({ name: name }, trips[name]);
    });

    function openTrip(t) {
      window.postMessage({ type: 'ultreia:map:trip', trip: t }, '*');
    }

    function stat(host, value, label) {
      if (!value) return;
      var wrap = document.createElement('span');
      wrap.className = 'u-tagcy-card__stat';
      var v = document.createElement('span');
      v.className = 'u-tagcy-card__stat-v';
      v.textContent = value;
      var l = document.createElement('span');
      l.className = 'u-tagcy-card__stat-l';
      l.textContent = label;
      wrap.appendChild(v);
      wrap.appendChild(l);
      host.appendChild(wrap);
    }

    function buildCard(t) {
      var card = document.createElement('button');
      card.type = 'button';
      card.className = 'u-tagcy-card';

      var media = document.createElement('span');
      media.className = 'u-tagcy-card__media';
      if (t.hero) {
        var img = document.createElement('img');
        img.src = t.hero;
        img.alt = t.name || '';
        img.loading = 'lazy';
        media.appendChild(img);
      }
      // Phone-only: trip name over the photo + "Desde $X" line below (see the
      // max-width:600px block — desktop keeps the full card and hides these).
      var mtitle = document.createElement('span');
      mtitle.className = 'u-tagcy-card__mtitle';
      mtitle.textContent = t.name || '';
      media.appendChild(mtitle);
      card.appendChild(media);

      if (t.price_from) {
        var mprice = document.createElement('span');
        mprice.className = 'u-tagcy-card__mprice';
        mprice.appendChild(document.createTextNode('Desde '));
        var b = document.createElement('b');
        b.textContent = t.price_from;
        mprice.appendChild(b);
        card.appendChild(mprice);
      }

      var content = document.createElement('span');
      content.className = 'u-tagcy-card__content';

      var metaRow = document.createElement('span');
      metaRow.className = 'u-tagcy-card__metarow';
      if (t.loc) {
        var loc = document.createElement('span');
        loc.textContent = t.loc;
        metaRow.appendChild(loc);
      }
      if (t.dates) {
        var dates = document.createElement('span');
        dates.className = 'u-tagcy-card__dates';
        dates.textContent = t.dates;
        metaRow.appendChild(dates);
      }
      if (metaRow.childNodes.length) content.appendChild(metaRow);

      var title = document.createElement('span');
      title.className = 'u-tagcy-card__title';
      title.textContent = t.name || '';
      content.appendChild(title);

      if (t.activities && t.activities.length) {
        var acts = document.createElement('span');
        acts.className = 'u-tagcy-card__activities';
        acts.textContent = t.activities.join(' · ');
        content.appendChild(acts);
      }

      var divider = document.createElement('span');
      divider.className = 'u-tagcy-card__divider';
      content.appendChild(divider);

      var stats = document.createElement('span');
      stats.className = 'u-tagcy-card__stats';
      stat(stats, t.duration, 'DURACIÓN');
      stat(stats, t.price_from, 'DESDE');
      stat(stats, t.format, 'FORMATO');
      content.appendChild(stats);

      var cta = document.createElement('span');
      cta.className = 'u-btn u-btn--ghost u-btn--sm u-tagcy-card__cta';
      cta.textContent = 'Ver viaje →';
      content.appendChild(cta);

      card.appendChild(content);
      card.addEventListener('click', function () { openTrip(t); });
      return card;
    }

    function buildEmpty(label) {
      var el = document.createElement('span');
      el.className = 'u-tagcy__empty';
      el.textContent = label;
      return el;
    }

    document.querySelectorAll('[data-agency-cards]').forEach(function (host) {
      var wrap = host.closest('[data-agency]');
      var agencyName = (wrap.getAttribute('data-agency') || '').toLowerCase();
      var viewallBtn = wrap.querySelector('[data-agency-viewall]');
      var cap = parseInt(wrap.closest('.u-tagcy').getAttribute('data-cards-per-agency'), 10) || 3;
      // Phone: every trip goes in the sideways swipe row, so no cap and no
      // "Ver todos" button (it stays hidden since nothing is left over).
      if (window.matchMedia('(max-width: 600px)').matches) cap = Infinity;

      var mine = byName.filter(function (t) {
        return (t.operator || '').toLowerCase() === agencyName;
      }).sort(function (a, b) {
        return (a.dateSort || '9999-99-99').localeCompare(b.dateSort || '9999-99-99');
      });

      if (!mine.length) {
        host.appendChild(buildEmpty(host.getAttribute('data-empty-label') || 'Próximamente'));
        return;
      }

      var upcoming = mine.filter(function (t) { return !t.dateSort || t.dateSort >= today; });
      var rest = mine.filter(function (t) { return t.dateSort && t.dateSort < today; });
      var ordered = upcoming.concat(rest);

      ordered.forEach(function (t, i) {
        var card = buildCard(t);
        if (i >= cap) { card.hidden = true; card.setAttribute('data-extra', '1'); }
        host.appendChild(card);
      });

      if (ordered.length > cap && viewallBtn) {
        viewallBtn.hidden = false;
        viewallBtn.addEventListener('click', function () {
          var hiddenCards = host.querySelectorAll('[data-extra="1"]');
          var willShow = hiddenCards.length && hiddenCards[0].hidden;
          hiddenCards.forEach(function (c) { c.hidden = !willShow; });
          viewallBtn.textContent = willShow
            ? viewallBtn.getAttribute('data-label-less')
            : viewallBtn.getAttribute('data-label-more');
        });
      }
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
